var App = App || {};
(function () {

	if (App.page) return;

	App.page = {

		_phone: {
			iti: null,
			utilsLoad: false,
			inited: false
		},

		debounce: function (fn, delay) {
			let timer;
			return function () {
				let context = this;
				let args = arguments;

				clearTimeout(timer);
				timer = setTimeout(function () {
					fn.apply(context, args);
				}, delay);
			};
		},

		trimCountryCode: function (iti, utilsLoad) {
			if (utilsLoad && iti && typeof iti.getNumber === 'function') {

				let cc = (iti.getSelectedCountryData() || {}).dialCode || '';
				let num = iti.getNumber(intlTelInput.utils.numberFormat.INTERNATIONAL);

				if (num !== '') {

					if (iti.isValidNumber()) {
						num = num.replace('+' + cc, '');
					} else {

						if (intlTelInput.utils.isValidNumber('+' + iti.telInput.value)) {
							num = '+' + iti.telInput.value;
							iti.setNumber(num);
							num = iti.getNumber(intlTelInput.utils.numberFormat.INTERNATIONAL).replace('+' + cc, '');
						} else {
							num = iti.telInput.value;
						}
					}

					if ((iti.getSelectedCountryData() || {}).iso2 === 'ua') {
						num = num.replace(/^0/, '');
					}

					return num;
				}

				return '';
			}

			return iti && iti.telInput ? iti.telInput.value : '';
		},

		safeLoadUtils: function (path) {
			const res = window.intlTelInput.loadUtils(path);
			return res instanceof Promise ? res : Promise.resolve(false);
		},

		bindPhone: function () {
			if (this._phone.inited) return;

			let input = document.querySelector("#phone");
			if (!input) return;

			if (typeof window.intlTelInput !== 'function') return;

			this._phone.inited = true;

			let utilsLoad = false;

			const iti = window.intlTelInput(input, {
				excludeCountries: ['ru'],
				initialCountry: (typeof currentCC !== 'undefined' && currentCC) ? currentCC : 'ua',
				countryOrder: ['ua', 'pl', 'de', 'fr', 'gb'],
				autoPlaceholder: 'aggressive',
				separateDialCode: true,
				strictMode: true,
				useFullscreenPopup: (typeof is_mobile === 'function') ? is_mobile() : false,
				i18n: {
					searchPlaceholder: 'Type country or code ...'
				}
			});

			this._phone.iti = iti;
			this._phone.utilsLoad = false;

			window.clearPhone = '';

			// utils
			this.safeLoadUtils('/assets/js/vendor/phone_country/utilsO.js').then(() => {
				utilsLoad = true;
				this._phone.utilsLoad = true;
			});

			let $phone = $('#phone');
			if ($phone.attr('data-value')) $phone.val($phone.attr('data-value'));

			$(input).on('input countrychange blur keyup', () => {

				input.value = this.trimCountryCode(iti, utilsLoad);

				let validPhone = !utilsLoad || (iti && typeof iti.isValidNumber === 'function' && iti.isValidNumber());

				if (validPhone) {
					$(input).closest('.demo__form__item-input').removeClass('demo__form__item-error');
					$('input[name=phone_int]').val(iti.getNumber(intlTelInput.utils.numberFormat.INTERNATIONAL));
				} else {
					$(input).closest('.demo__form__item-input').addClass('demo__form__item-error');
					$('input[name=phone_int]').val('');
				}
			});
		},

		send_form: function (form) {
			if (form.chkfrm2) form.chkfrm2.value = 'ok';

			let $form = $(form);

			let formData = {};
			$form.serializeArray().forEach(function (field) {
				formData[field.name] = field.value;
			});

			formData.action = 'send';

			if (typeof md5 === 'function' && form.email) {
				formData.hash = md5(document.location.host + form.email.value);
			}

			const g = (k) => (typeof window[k] !== 'undefined' ? window[k] : '');
			if (g('ga_cid') || g('ga_lid') || g('ga_cmp') || g('ga_src')) {
				Object.assign(formData, {
					ga_cid: g('ga_cid') + ':' + g('ga_lid'),
					ga_typ: g('ga_typ'),
					ga_src: g('ga_src'),
					ga_mdm: g('ga_mdm'),
					ga_cmp: g('ga_cmp'),
					ga_cnt: g('ga_cnt'),
					ga_trm: g('ga_trm'),
					ga_lid: g('ga_lid'),
					ga_adid: g('ga_adid'),
					ga_matchtype: g('ga_matchtype'),
					ga_adposition: g('ga_adposition'),
					ga_device: g('ga_device'),
					ga_device_model: g('ga_device_model'),
					ga_lang: g('ga_lang'),
					ga_placement: g('ga_placement'),
					ga_target: g('ga_target'),
					ga_geo: g('ga_geo'),
					ga_physical_geo: g('ga_physical_geo'),
					ga_network: g('ga_network')
				});
			}

			$.ajax({
				type: "POST",
				url: form.action,
				data: formData,
				dataType: "text",
				success: function (resp, status, xhr) {
					const ct = (xhr.getResponseHeader('Content-Type') || '').toLowerCase();
					if (ct.includes('javascript')) {
						$.globalEval(resp);
					}
				}
			});
		},

		check_form: function (form) {

			let checkform = $(form);
			let isValid = true;

			let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

			checkform.find('input.req, textarea.req').each(function () {

				let field = $(this);
				let parent = field.closest('.demo__form__item-input');
				let val = $.trim(field.val());

				parent.removeClass('demo__form__item-error');

				if (!val) {
					parent.addClass('demo__form__item-error');
					isValid = false;
					return;
				}

				if (field.attr('type') === 'email' || field.hasClass('email')) {
					if (!emailPattern.test(val)) {
						parent.addClass('demo__form__item-error');
						isValid = false;
					}
				}

			});

			if (!isValid) return false;

			// reCAPTCHA: у режимі checkbox вимагаємо відмітку, у invisible — запускаємо челендж
			let $captcha = checkform.find('.g-recaptcha');
			if ($captcha.length && window.grecaptcha && typeof grecaptcha.getResponse === 'function') {
				if (!grecaptcha.getResponse()) {
					if ($captcha.attr('data-size') === 'invisible') {
						this._pendingForm = form;
						grecaptcha.execute();
						return true; // send_form викличе demoCaptchaDone
					}
					$captcha.closest('.demo__form__item-input').addClass('demo__form__item-error');
					return false;
				}
				$captcha.closest('.demo__form__item-input').removeClass('demo__form__item-error');
			}

			this.send_form(form);
			return true;
		},

		bind: function () {

			// "+ Добавить пожелания": разово показує textarea замість тогла
			$('.js-demo-details').on('click', function () {
				$(this).hide();
				$('.demo__form__details-body').show();
			});

			// кнопки-діапазони: у прихований #team їде максимум вибраного діапазону
			$('#companySize button').on('click', function () {
				$('#companySize button').removeClass('btn-semi-active');
				$(this).addClass('btn-semi-active');
				$('#team').val($(this).val());
			});

			$(document).on('click', '.js-submit-form', function () {
				let form = this.form;
				App.page.check_form(form);
			});
		},

		onload: function () {
			let $link = $('<link>', {
				rel: 'stylesheet',
				type: 'text/css',
				href: '/assets/css/vendor/intlTelInput.min.css'
			});

			$link.on('load', function () {
				document.documentElement.style.setProperty('--iti-path-flags-1x', 'url(/assets/img/phone_country/flags_n.png)');
				document.documentElement.style.setProperty('--iti-path-flags-2x', 'url(/assets/img/phone_country/flags_n@2x.png)');
				document.documentElement.style.setProperty('--iti-path-globe-1x', 'url(/assets/img/phone_country/globe.png)');
				document.documentElement.style.setProperty('--iti-path-globe-2x', 'url(/assets/img/phone_country/globe@2x.png)');
				document.documentElement.style.setProperty('--iti-border-gray', 'rgba(0, 0, 0, 0.2)');
				document.documentElement.style.setProperty('--iti-hover-color', 'var(--colors-slate-100)');
				App.page.bindPhone();
			});

			$link.appendTo('head');
			App.page.bind();
		},
	};

})();
// Callback для invisible reCAPTCHA (data-callback="demoCaptchaDone")
window.demoCaptchaDone = function () {
	if (App.page._pendingForm) {
		let form = App.page._pendingForm;
		App.page._pendingForm = null;
		App.page.send_form(form);
	}
};
$(function () {
	App.page.onload();
});